// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__2z8eQ","rootCenter":"LoadMoreObserver_rootCenter__3-UlN","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__3phGO"};